export default "__VITE_ASSET__CVPNT62R__"